const retail = {
    namespaced: true,
    state: () => {
        return {
            //корзина
            basket: [],
        }
    },
    getters: {

        /**
         * Включен ли сейчас режим "Розничный магазин" (НЕ ПРОВЕРЯЕТ, что выбран конкретный магазин)
         */
        isRetailModeOn(state, getters, rootState, rootGetters) {
            let connection = rootGetters.getConnection;

            //если функционал розничных магазинов отключен
            if(!rootGetters.isRetailStoreEnabled) {
                return false;
            }

            //если функционал интернет-магазина отключен
            if(!rootGetters.isOnlineStoreEnabled) {
                return true
            }

            return connection.retail_mode ? connection.retail_mode: false;
        },

        /**
         * Включен режим "Розничный магазин" (проверяет также, что магазин выбран)
         */
        getRetailMode(state, getters) {
            return getters.isRetailModeOn && getters.getShopId > 0;
        },

        /**
         * Ид выбранного розничного магазина
         */
        getShopId(state, getters, rootState, rootGetters) {

            let connection = rootGetters.getConnection;
            return connection.retail_shop_id ? connection.retail_shop_id : 0;
        },

        /**
         * Получает корзину
         */
        getBasket(state) {
            return state.basket;
        },

        /**
         * Получает крзину по текущему выбранному магазину
         */
        getShopBasket(state, getters) {
            return state.basket.filter(item => item.shopId == getters.getShopId);
        },


        /**
         * Проверяет есть ли товар в корзине
         */
        inBasket: (state, getters) => (pid) => {
            return state.basket.find(item => item.id == pid && item.shopId == getters.getShopId) !== undefined;
        },

        /**
         * Получает указанный товар из корзины
         */
        getProductInBasket: (state, getters) => (pid) => {
            let item = state.basket.find(item => item.id == pid && item.shopId == getters.getShopId)
            return item;
        },

        /**
         * Получает количетсво товаров в корзине
         */
        getBasketCount(state, getters) {
            let cnt = 0;
            getters.getShopBasket.forEach(item => cnt += item.quantity)
            return cnt;
        },

    },
    mutations: {

        /**
         * Устанавливает корзину
         */
        setBasket: (state, value) => {
            state.basket = value;
        },

    },

    actions: {

        /**
         * Устанавливает/снимает режим "Розничный магазин"
         */
        setRetailModeOn (context, value) {
            let connection = context.rootGetters.getConnection;
            connection.retail_mode = value;
            context.commit('updateConnection', connection,{ root: true });
        },

        /**
         * Устанавливает выбранный розничный магазин
         */
        setRetailShopId (context, value) {
            let connection = context.rootGetters.getConnection;
            connection.retail_shop_id = value;
            context.commit('updateConnection', connection,{ root: true });

        },

        /**
         * Обновляет товар в корзине
         */
        updateBasketItem (context, data) {
            data.shopId = context.getters.getShopId;

            let basket = context.getters.getBasket;
            let item = basket.find(item => item.id == data.id && item.shopId == data.shopId);

            if (item) {
                item.quantity = data.quantity;
                if(item.quantity == 0) {
                    var index = basket.indexOf(item);
                    if (index !== -1) {
                        basket.splice(index, 1);
                    }
                }
            } else if (data.quantity > 0) {
                basket.push(data);
            }

            context.commit('setBasket', basket);
            
        },

        /**
         * Обновляет товар в корзине
         */
        clear (context) {
            let shopId = context.getters.getShopId;

            let basket = context.getters.getBasket;
            let list = basket.filter(item => item.shopId != shopId);
            
            context.commit('setBasket', list);
            
        },

        
    }

}

export default retail;